import { LevelForm } from 'v2/types/LevelModel';

export const initialValues: LevelForm = {
  levelPoints: 0,
  dailyBonusPercent: 0,
  referralBonusPercent: 0,
  rewards: [],
};
